module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo && _vm.playTheVideo) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo,
      "on-complete": _vm.onVideoComplete
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-video-icons",
    class: {
      'trailexp': _vm.isTrialExpired, 'right-hover-width': _vm.addRightHoverWidthClass, 'right-hover-enjoy': _vm.addRightHoverEnjoyClass
    },
    on: {
      "mouseleave": function($event) {
        return _vm.resetClass(true)
      }
    }
  }, [_c('div', {
    staticClass: "icons-hover",
    class: {
      'icon-hover-width': _vm.addIconHoverWidthClass
    }
  }, [_c('ul', [(_vm.currentStatus.liked === '1') ? _c('li', [_c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "aria-label": "Add video to a playlist",
      "title": "Add to Playlist",
      "id": "addToPlayerTop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('addToPlayerTop')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-label": "New playlist name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-label": "Insert New Playlist",
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('addToPlayerTop')
      }
    }
  })]), _vm._v(" "), _c('a', [_c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-heart pink-filled",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]) : _c('li', [_c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "aria-label": "Add video to a playlist",
      "title": "Add to Playlist",
      "id": "addToPlayerTop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('addToPlayerTop')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-label": "New playlist name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-label": "Insert New Playlist",
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('addToPlayerTop')
      }
    }
  })]), _vm._v(" "), _c('a', [_c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-heart-o",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "rate",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.changeHeight,
      "focus": _vm.changeHeight,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        return _vm.resetClass(true)
      },
      "mouseover": _vm.changeHeight
    }
  }, [_vm._v("Suggest a TONE Topic")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "share",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showSharing,
      "focus": _vm.showSharing,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        return _vm.resetClass(true)
      },
      "mouseover": _vm.showSharing
    }
  }, [_vm._v("Share")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "enjoy",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showEnjoy,
      "focus": _vm.showEnjoy,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        return _vm.resetClass(true)
      },
      "mouseover": _vm.showEnjoy
    }
  }, [_vm._v("Rating")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRateHoverBox),
      expression: "showRateHoverBox"
    }],
    staticClass: "rate-hover-box",
    class: {
      'z-index': _vm.showRateHoverBox
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_c('span', [_vm._v("Let us know what topics you want to see on TONE")]), _vm._v(" "), (_vm.currentStatus.opinion === '1') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('travel')
      }
    }
  }, [_vm._v("\n                                        Travel\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('travel')
      }
    }
  }, [_vm._v("\n                                        Travel\n                                    ")])]), _vm._v(" "), (_vm.currentStatus.opinion === '2') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('dating')
      }
    }
  }, [_vm._v("\n                                        Dating\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('dating')
      }
    }
  }, [_vm._v("\n                                        Dating\n                                    ")])]), _vm._v(" "), (_vm.currentStatus.opinion === '3') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('news')
      }
    }
  }, [_vm._v("\n                                        News\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('news')
      }
    }
  }, [_vm._v("\n                                        News\n                                    ")])]), _vm._v(" "), (_vm.currentStatus.opinion === '4') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('recipes')
      }
    }
  }, [_vm._v("\n                                        Recipes\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('recipes')
      }
    }
  }, [_vm._v("\n                                        Recipes\n                                    ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShareHoverBox),
      expression: "showShareHoverBox"
    }],
    staticClass: "share-hover-box",
    class: {
      'z-index': _vm.showShareHoverBox
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_c('div', {
    staticClass: "social-share-manage"
  }, [(_vm.currentVideo) ? _c('social-sharing', {
    directives: [{
      name: "a11y-sharing-disabled",
      rawName: "v-a11y-sharing-disabled",
      value: (_vm.isVideoPrivate),
      expression: "isVideoPrivate"
    }],
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "network-tag": "button",
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1))) ? _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-2x fa-share-square-o cursor",
    attrs: {
      "aria-label": "Share",
      "title": "Share"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.corporateInfo && (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1)) ? _c('span', [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "popupsharingoptionlink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share with " + _vm._s(_vm.user.isSuperUser ? _vm.user.corporationName : _vm.corporateInfo.name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnjoyHoverBox),
      expression: "showEnjoyHoverBox"
    }],
    staticClass: "enjoy-hover-box",
    class: {
      'z-index': _vm.showEnjoyHoverBox
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_c('div', {
    staticClass: "rating"
  }, [_c('p', [_vm._v("So, what did you think?")]), _vm._v(" "), (_vm.currentStatus.rating === '1') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('1')
      }
    }
  }, [_vm._v("\n                                            1 - Not for me\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('1')
      }
    }
  }, [_vm._v("\n                                            1 - Not for me\n                                        ")])]), _vm._v(" "), (_vm.currentStatus.rating === '2') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('2')
      }
    }
  }, [_vm._v("\n                                            2 - Just ok\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('2')
      }
    }
  }, [_vm._v("\n                                            2 - Just ok\n                                        ")])]), _vm._v(" "), (_vm.currentStatus.rating === '3') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('3')
      }
    }
  }, [_vm._v("\n                                            3 - Worth it\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('3')
      }
    }
  }, [_vm._v("\n                                            3 - Worth it\n                                        ")])]), _vm._v(" "), (_vm.currentStatus.rating === '4') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('4')
      }
    }
  }, [_vm._v("\n                                            4 - Spot on\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('4')
      }
    }
  }, [_vm._v("\n                                            4 - Spot on\n                                        ")])])])])])])])])]), _vm._v(" "), (_vm.videoSqueeze) ? _c('div', {
    staticClass: "watch-again"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "congratz"
  }, [_c('button', {
    staticClass: "btn btn-danger backtohomebutton btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.redirectToHome()
      }
    }
  }, [_vm._v("Back to Home Page")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.videoMessage) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-6"
  }, [_c('div', {
    staticClass: "current-video-img"
  }, [_c('div', {
    staticClass: "responsiveSocialIcon"
  }, [(_vm.videoGifIndex === 0) ? _c('img', {
    attrs: {
      "src": require("../assets/fireworkssmall.png"),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoGifIndex === 1) ? _c('img', {
    attrs: {
      "src": require("../assets/baloonssmall.png"),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoGifIndex === 2) ? _c('img', {
    attrs: {
      "src": require("../assets/confettismall.png"),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoGifIndex === 3) ? _c('img', {
    attrs: {
      "src": require("../assets/sparkelssmall.gif"),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "responsiveSocialIconBox"
  }, [_c('social-sharing', {
    directives: [{
      name: "a11y-sharing-disabled",
      rawName: "v-a11y-sharing-disabled",
      value: (_vm.isVideoPrivate),
      expression: "isVideoPrivate"
    }],
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "network-tag": "button",
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "btn btn-link",
    on: {
      "click": _vm.replayVideo
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-play",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("    watch again\n                            ")]), _vm._v(" "), (_vm.currentStatus.liked === '1') ? _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "cursor fa fa-heart heartIcon",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  }) : _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "cursor fa fa-heart-o heartIcon",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-lg-6"
  }, [_c('div', {
    staticClass: "rating"
  }, [_c('ul', {
    staticClass: "chart-skills"
  }, [_c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('1')
    }
  }, [_c('button', {
    staticClass: "tone-heading-button",
    attrs: {
      "type": "button",
      "aria-label": "Not for me (1 out of 4)",
      "aria-pressed": _vm.applyRatingClass('1') ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('1')
      }
    }
  }, [_c('span', [_vm._v("Not for me")])])]), _vm._v(" "), _c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('2')
    }
  }, [_c('button', {
    staticClass: "tone-heading-button",
    attrs: {
      "type": "button",
      "aria-label": "Just ok (2 out of 4)",
      "aria-pressed": _vm.applyRatingClass('2') ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('2')
      }
    }
  }, [_c('span', [_vm._v("Just ok")])])]), _vm._v(" "), _c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('3')
    }
  }, [_c('button', {
    staticClass: "tone-heading-button",
    attrs: {
      "type": "button",
      "aria-label": "Worth it (3 out of 4)",
      "aria-pressed": _vm.applyRatingClass('3') ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('3')
      }
    }
  }, [_c('span', [_vm._v("Worth it")])])]), _vm._v(" "), _c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('4')
    }
  }, [_c('button', {
    staticClass: "tone-heading-button",
    attrs: {
      "type": "button",
      "aria-label": "Spot on (4 out of 4)",
      "aria-pressed": _vm.applyRatingClass('4') ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('4')
      }
    }
  }, [_c('span', [_vm._v("Spot on")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.showRatingMessage) ? _c('h2', {
    staticClass: "pinkh2"
  }, [_vm._v("Thanks for your feedback!")]) : _vm._e()])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "text-right mobileiconholder"
  }, [_c('ul', {
    staticClass: "mobilesocialicons"
  }, [(_vm.currentStatus.liked === '1') ? _c('li', [_c('a', [_c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-heart pink-filled",
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]) : _c('li', [_c('a', [_c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-heart-o",
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "aria-label": "Add video to a playlist",
      "title": "Add to Playlist",
      "id": _vm.currentVideo.mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  }, [_c('img', {
    staticClass: "menuiconbutton",
    attrs: {
      "src": require("../assets/playlist-icon.png"),
      "title": "Playlist",
      "alt": "PLAYLIST"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-label": "New playlist name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-label": "Insert New Playlist",
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  })])])]), _vm._v(" "), (_vm.currentVideo) ? _c('social-sharing', {
    directives: [{
      name: "a11y-sharing-disabled",
      rawName: "v-a11y-sharing-disabled",
      value: (_vm.isVideoPrivate),
      expression: "isVideoPrivate"
    }],
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "network-tag": "button",
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": _vm.currentVideo.title,
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1))) ? _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-2x fa-share-square-o cursor",
    attrs: {
      "aria-label": "Share video"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "text-right mobileiconholder"
  }, [_c('ul', {
    staticClass: "mobilesocialicons"
  }, [(_vm.currentStatus.liked === '1') ? _c('li', {
    style: ({
      backgroundColor: '#A9A9A9 !important'
    })
  }, [_c('a', [_c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-heart pink-filled",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    }),
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]) : _c('li', [_c('a', [_c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-heart-o",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    }),
    attrs: {
      "aria-label": "Like video"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "plusicon btn-group",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    })
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "aria-label": "Add video to a playlist",
      "title": "Add to Playlist",
      "id": _vm.currentVideo.mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  }, [_c('img', {
    staticClass: "menuiconbutton",
    attrs: {
      "src": require("../assets/playlist-icon.png"),
      "title": "Playlist",
      "alt": "PLAYLIST"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-label": "New playlist name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-label": "Insert New Playlist",
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  })])])]), _vm._v(" "), (_vm.currentVideo) ? _c('social-sharing', {
    directives: [{
      name: "a11y-sharing-disabled",
      rawName: "v-a11y-sharing-disabled",
      value: (_vm.isVideoPrivate),
      expression: "isVideoPrivate"
    }],
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "network-tag": "button",
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": _vm.currentVideo.title,
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1))) ? _c('i', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "fa fa-2x fa-share-square-o cursor",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    }),
    attrs: {
      "aria-label": "Share video"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.currentVideo.Description) + "\n                        ")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                        ")]), _vm._v(" "), (!_vm.isTrialExpired) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-3"
  }, [_c('button', {
    staticClass: "btn recently-watched-btn btn-transparent btn-lg",
    style: ([_vm.viewTranscript ? {
      color: _vm.$a11yTextColor(this.getCorpButtonColor) + ' !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    } : {
      color: _vm.getCorpButtonColor + ' !important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    }]),
    on: {
      "click": _vm.toggleViewTranscript
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewTranscript),
      expression: "!viewTranscript"
    }]
  }, [_vm._v("View Transcript")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }]
  }, [_vm._v("Hide Transcript")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9 vtrnscript"
  }, [(_vm.getCurrentVideoTranscript) ? _c('div', {
    staticClass: "side-content",
    style: ({
      'border-left-color': this.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }],
    staticClass: "boxes",
    class: {
      'animated fadeIn': _vm.viewTranscript, 'animated fadeOut': !_vm.viewTranscript
    }
  }, [_c('pre', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentVideoTranscript.vtt_file)
    }
  }, [_vm._v("\n                                        ")])])])]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos && !_vm.isTrialExpired) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.recommendationList) ? _c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.carouselSettings, false), _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + reccentVideo.mediaid + '/' + reccentVideo.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image,
        "title": reccentVideo.title,
        "alt": reccentVideo.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                            ")])])])])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])]), _vm._v(" "), (_vm.showMemberOverlay) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showMemberOverlay
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelMemberModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMemberModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('p', [_c('b', [_vm._v("We hope you're enjoying your free access to TONE Lite, a limited preview experience!")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("In order to customize your viewing and to be able to produce videos relevant to you, we occasionally need to ask you to update your subscription information")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent",
    attrs: {
      "id": "videoplayer_videoredirect"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/becomemember')
      }
    }
  }, [_vm._v("\n                        Update my Membership\n                    ")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    attrs: {
      "id": "videoplayer_videostay"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMemberModal()
      }
    }
  }, [_vm._v("\n                        Not right now, take me to free video\n                    ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    attrs: {
      "aria-label": "Share with"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "aria-label": "Corporate recipients",
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "aria-label": "Email recipients",
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "aria-label": "Type your message",
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentVideo.img,
      "title": _vm.currentVideo.title,
      "alt": _vm.currentVideo.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.currentVideo.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.currentVideo.Description.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      color: _vm.$a11yTextColor(_vm.getCorpButtonColor) + ' !important',
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share this video\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "aria-label": "Email recipients",
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Optional Message",
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Email preview",
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02cadb06", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02cadb06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/VideoPlayer.vue